export const setOrderPromotionDetails = (orderPromotionDetail) => ({
    type: 'SET_ORDER_PROMOTIONS',
    payload: orderPromotionDetail
});

export const resetOrderPromotionDetails = () => ({
    type: 'RESET_ORDER_PROMOTIONS'
});